import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const Portfolio: React.FC = () => {
  const projects = [
    {
      title: 'Indian Suraksha Force',
      type: 'HTML Website',
      description: 'Private security service agency website built for digital presence, service visibility, and regional customer reach.',
      tech: ['HTML', 'CSS', 'JavaScript', 'XML', 'robots.txt', '.htaccess'],
      link: 'https://indiansurakshaforce.com/',
      image: '/project_screenshot/ISF.png'
    },
    {
      title: 'Savitur Rockland',
      type: 'WordPress Website',
      description: 'School management system built using WordPress with admin dashboard and content management.',
      tech: ['WordPress', 'PHP', 'MySQL'],
      link: 'https://saviturrockland.com',
      image: '/project_screenshot/savitur_rockland.png'
    },
    {
      title: 'Barak Bani News',
      type: 'WordPress Website',
      description: 'News portal built using WordPress with custom themes and content management.',
      tech: ['WordPress', 'PHP', 'MySQL'],
      link: 'https://barakbaninews.com',
      image: '/project_screenshot/epaper.barakbaninews.com.png'
    },
    {
      title: 'Terve Life Sciences',
      type: 'PHP Website',
      description: 'Business website for life sciences company built with PHP and modern UI.',
      tech: ['PHP', 'HTML', 'CSS', 'JavaScript'],
      link: 'https://tervelifesciences.in',
      image: '/project_screenshot/terve_lifescience.png'
    },
    {
      title: 'SDDKB Missions School',
      type: 'PHP Website',
      description: 'School website built with PHP featuring student management and information portal.',
      tech: ['PHP', 'MySQL', 'Bootstrap'],
      link: 'https://sddkbmissionschool.com',
      image: '/project_screenshot/swami_dhananjoy_das_kathia_baba_mission_school.png'
    },
    {
      title: 'Konscious Lifestyle',
      type: 'WordPress E-commerce',
      description: 'E-commerce platform for lifestyle products with payment integration.',
      tech: ['WordPress', 'WooCommerce', 'PHP'],
      link: 'https://konsciouslifestyle.in',
      image: '/project_screenshot/konscious_lifestyle.png'
    },
    {
      title: 'Epaper Barak Bani News',
      type: 'Node.js Application',
      description: 'Digital newspaper application built with Node.js for online publication.',
      tech: ['Node.js', 'Express', 'MongoDB'],
      link: 'https://epaper.barakbaninews.com',
      image: '/project_screenshot/epaper.barakbaninews.com.png'
    }
  ];

  const cardVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6 } }
  };

  const featuredProjects = projects.slice(0, 6);

  useEffect(() => {
    // Prevent right-click context menu on portfolio images
    const handleContextMenu = (e: MouseEvent) => {
      if ((e.target as HTMLElement)?.closest('.project-image img')) {
        e.preventDefault();
        return false;
      }
    };

    // Prevent image dragging
    const handleDragStart = (e: DragEvent) => {
      if ((e.target as HTMLElement)?.closest('.project-image img')) {
        e.preventDefault();
        return false;
      }
    };

    document.addEventListener('contextmenu', handleContextMenu);
    document.addEventListener('dragstart', handleDragStart);

    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
      document.removeEventListener('dragstart', handleDragStart);
    };
  }, []);

  return (
    <section id="portfolio" className="portfolio">
      <motion.h2
        className="wow fadeInUp"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
      >
        Our Portfolio
      </motion.h2>
      <div className="portfolio-grid">
        {featuredProjects.map((project, index) => (
          <motion.div
            key={index}
            className={`project-card wow fadeInUp`}
            data-wow-delay={`${0.2 + index * 0.1}s`}
            variants={cardVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            transition={{ delay: index * 0.1 }}
          >
            <div className="project-image">
              {project.image ? (
                <img
                  src={process.env.PUBLIC_URL + project.image}
                  alt={`${project.title} screenshot`}
                  draggable="false"
                  onContextMenu={(e) => e.preventDefault()}
                />
              ) : (
                <div className="placeholder-image">Project Screenshot</div>
              )}
            </div>
            <div className="project-info">
              <h3>{project.title}</h3>
              <p className="project-type">{project.type}</p>
              <p>{project.description}</p>
              <div className="tech-stack">
                {project.tech.map((tech, i) => (
                  <span key={i} className="tech-badge">{tech}</span>
                ))}
              </div>
              <a href={project.link} target="_blank" rel="noopener noreferrer" className="view-live-btn">
                View Live
              </a>
            </div>
          </motion.div>
        ))}
      </div>
      {projects.length > featuredProjects.length && (
        <div className="portfolio-actions">
          <Link to="/portfolio" className="btn-secondary">Load More Projects</Link>
        </div>
      )}
    </section>
  );
};

export default Portfolio;
